import React, { useEffect, useState } from "react";
import FinancialReportBaseComponentHeader from "./CommonComponentOfFinancialReportFolder/FinancialReportBaseComponentHeader.jsx";
import useApi from "../hooks/useApiGetPost";
import ProfitLossGroup from "./ProfitAndLossModeComponentFolder/ProfitLossGroup.jsx";
import ProfitLossGroupPDF from "./pdf_for_report/ProfitLossPDFFolder/ProfitLossGroupPDF.js";
import ProfitLossDetailedPDF from "./pdf_for_report/ProfitLossPDFFolder/ProfitLossDetailedPDF.js";
import ProfitLossDetailed from "./ProfitAndLossModeComponentFolder/ProfitLossDetailedNew.jsx";
import ProfitLossMonth from "./ProfitAndLossModeComponentFolder/ProfitLossMonth.jsx";
import ProfitLossMonthGroup from "./ProfitAndLossModeComponentFolder/ProfitLossMonthGroup.jsx";
import ProfitLossMonthPDF from "./pdf_for_report/ProfitLossPDFFolder/ProfitLossMonthPDF.js";

function ProfitAndLossReport() {
  const COMPANY_CODE = localStorage.getItem("companyCode") || "-";
  const API_PATHS = localStorage.getItem("apiPaths")
    ? JSON.parse(localStorage.getItem("apiPaths"))
    : [];
  const [cleanedData, setCleanedData] = useState(null);
  const [isFinancialDataReady, setIsFinancialDataReady] = useState(false);
  const [hasCalledInitialAPI, setHasCalledInitialAPI] = useState(false);

  const requiredColumns = ["DEBIT", "CREDIT", "BALANCE"];

  const modeComponentMap = {
    PLGROUP: ProfitLossGroup,
    PLACC: ProfitLossDetailed,
    PLMONTH: ProfitLossMonth,
    PLMONTHGRP: ProfitLossMonthGroup,
  };

  const pdfComponentMap = {
    PLGROUP: ProfitLossGroupPDF,
    PLACC: ProfitLossDetailedPDF,
    PLMONTH: ProfitLossMonthPDF,
  };

  const {
    data: datagetTrialBalanceReport,
    loading: loadinggetTrialBalanceReport,
    get: getTrialBalanceReport,
  } = useApi();

  const {
    data: datagetgetFinancialDateApi,
    loading: loadinggetFinancialDateApi,
    get: getFinancialDateApi,
  } = useApi();

  const today = new Date().toISOString().split("T")[0];

  const mode_list = [
    {
      mode_name: "Profit Loss (Group)",
      mode_code: "PLGROUP",
      is_selected: true,
    },
    {
      mode_name: "Profit Loss Detailed",
      mode_code: "PLACC",
      is_selected: false,
    },
    {
      mode_name: "Profit Loss Month",
      mode_code: "PLMONTH",
      is_selected: false,
    },
    {
      mode_name: "Profit Loss Month (Group)",
      mode_code: "PLMONTHGRP",
      is_selected: false,
    },
  ];

  const currentUser = JSON.parse(localStorage.getItem("currentUser")) || [];
  const local_department_list_array = currentUser.map((item) => ({
    ...item,
    department_name: item.DEPTNO,
    department_code: item.DEPTNO,
    is_selected: false,
  }));

  const department_list = [
    { department_name: "ALL", department_code: "ALL", is_selected: true },
    ...local_department_list_array,
  ];

  const checkbox_list = [
    {
      checkbox_name: "Include Zero Balance",
      checkbox_code: "Include_Zero_Balance",
      is_selected: false,
    },
    {
      checkbox_name: "Activate From Date For Movement",
      checkbox_code: "Activate_From_Date_For_Movement",
      is_selected: false,
    },
  ];

  const toggle_list = [
    {
      toggle_name: "Include Stock",
      toggle_code: "Include_Stock",
      is_selected: false,
    },
    {
      toggle_name: "Plus Qty Only",
      toggle_code: "Plus_Qty_Only",
      is_selected: false,
    },
  ];

  const parentInitialObject = {
    report_name: "Profit and Loss Report",
    from_date: today,
    to_date: today,
    mode_list_array: mode_list,
    department_list_array: department_list,
    checkbox_list_array: checkbox_list,
    toggle_button_list_array: toggle_list,
  };

  const [parentDetails, setParentDetails] = useState(parentInitialObject);
  const [selectedMode, setSelectedMode] = useState(
    parentInitialObject.mode_list_array?.find((item) => item.is_selected)
      ?.mode_code,
  );

  // 1️⃣ Fetch financial API on mount
  useEffect(() => {
    const financialDateApi = `${API_PATHS[0].API_CONFIG}/api/Cpayscount/${COMPANY_CODE}/companyinfo/-/-`;
    console.log("🔹 Fetching Financial Info:", financialDateApi);
    getFinancialDateApi(financialDateApi);
  }, []);

  // 2️⃣ When financial data is fetched, set from/to dates
  useEffect(() => {
    if (
      datagetgetFinancialDateApi &&
      Array.isArray(datagetgetFinancialDateApi) &&
      datagetgetFinancialDateApi.length > 0
    ) {
      const fyStart = datagetgetFinancialDateApi[0]?.fystart?.split("T")[0];
      const fyEnd = datagetgetFinancialDateApi[0]?.ftend?.split("T")[0];

      if (fyStart && fyEnd) {
        console.log(`✅ Financial Year Range: ${fyStart} → ${fyEnd}`);

        const initialTo = fyEnd > today ? today : fyEnd;

        setParentDetails((prev) => ({
          ...prev,
          from_date: fyStart,
          to_date: initialTo,
        }));

        setIsFinancialDataReady(true);
      }
    }
  }, [datagetgetFinancialDateApi]);

  // 3️⃣ Call initial API only once after financial dates are ready
  useEffect(() => {
    if (isFinancialDataReady && !hasCalledInitialAPI) {
      console.log(
        "🚀 Financial data ready — calling initial Profit & Loss API...",
      );
      callAPIToGetTrialBalance();
      setHasCalledInitialAPI(true);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isFinancialDataReady]);

  // 4️⃣ Auto-refresh API when user updates filters/dates
  useEffect(() => {
    if (hasCalledInitialAPI) {
      console.log(
        "🔄 User changed filters or dates — refreshing Profit & Loss API...",
      );
      const debounceTimeout = setTimeout(() => {
        callAPIToGetTrialBalance();
      }, 500); // prevents too many API calls in quick succession
      return () => clearTimeout(debounceTimeout);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [
    parentDetails.from_date,
    parentDetails.to_date,
    parentDetails.checkbox_list_array,
    parentDetails.toggle_button_list_array,
    parentDetails.department_list_array,
    parentDetails.mode_list_array,
  ]);

  const callAPIToGetTrialBalance = () => {
    const {
      from_date,
      to_date,
      checkbox_list_array,
      toggle_button_list_array,
      mode_list_array,
    } = parentDetails;

    const zero = checkbox_list_array.find(
      (item) => item.checkbox_name === "Include Zero Balance",
    )?.is_selected
      ? "y"
      : "-";
    const include_stock = toggle_button_list_array.find(
      (item) => item.toggle_name === "Include Stock",
    )?.is_selected
      ? "y"
      : "-";
    const plus_qty = toggle_button_list_array.find(
      (item) => item.toggle_name === "Plus Qty Only",
    )?.is_selected
      ? "y"
      : "-";
    const selected_department = "ALL";
    const period = "-";
    const selectedMode = mode_list_array.find(
      (item) => item.is_selected,
    )?.mode_code;

    const apiURL = `${API_PATHS[0].API_CONFIG}/api/CRMProfitLoss/${COMPANY_CODE}/${selectedMode}/${from_date}/${to_date}/${zero}/${period}/${selected_department}/${include_stock}/${plus_qty}`;

    console.log("📡 Fetching Profit & Loss Data:", apiURL);
    getTrialBalanceReport(apiURL);
  };

  // 5️⃣ Clean report data
  useEffect(() => {
    if (datagetTrialBalanceReport) {
      console.log(
        `🧹 before Cleaning  ${datagetTrialBalanceReport}`,
        parentDetails.mode_list_array?.find((item) => item.is_selected)
          ?.mode_code,
      );

      if (
        parentDetails.mode_list_array?.find((item) => item.is_selected)
          ?.mode_code === "PLMONTH"
      ) {
        setCleanedData(datagetTrialBalanceReport);
      } else {
        const cleaned = datagetTrialBalanceReport.filter((row) =>
          requiredColumns.every(
            (col) => row[col] !== null && row[col] !== undefined,
          ),
        );
        console.log(`🧹 Cleaned ${cleaned.length} rows`);
        setCleanedData(cleaned);
      }
    }
  }, [datagetTrialBalanceReport]);

  const selected_mode_table_structure = [
    {
      mode_table_name: "Profit Loss (Group)",
      mode_table_code: "PLGROUP",
      mode_table_columns: [
        { column_name: "NODE", column_key_from_api: "NODE" },
        { column_name: "GROUP CODE", column_key_from_api: "GROUP CODE" },
        { column_name: "DEBIT", column_key_from_api: "DEBIT" },
        { column_name: "CREDIT", column_key_from_api: "CREDIT" },
        { column_name: "BALANCE", column_key_from_api: "BALANCE" },
      ],
    },
    {
      mode_table_name: "Profit Loss Detailed",
      mode_table_code: "PLACC",
      mode_table_columns: [
        { column_name: "NODE", column_key_from_api: "NODE" },
        { column_name: "GROUP CODE", column_key_from_api: "GROUP CODE" },
        { column_name: "ACCOUNT", column_key_from_api: "ACCOUNT" },
        { column_name: "DESCRIPTION", column_key_from_api: "DESCRIPTION" },
        { column_name: "DEBIT", column_key_from_api: "DEBIT" },
        { column_name: "CREDIT", column_key_from_api: "CREDIT" },
        { column_name: "BALANCE", column_key_from_api: "BALANCE" },
      ],
    },
    {
      mode_table_name: "Profit Loss Month",
      mode_table_code: "PLMONTH",
      mode_table_columns: [
        { column_name: "Account", column_key_from_api: "Account" },
        { column_name: "Descriptiion", column_key_from_api: "Descriptiion" },
        { column_name: "year", column_key_from_api: "year" },
        { column_name: "Jan", column_key_from_api: "Jan" },
        { column_name: "Feb", column_key_from_api: "Feb" },
        { column_name: "Mar", column_key_from_api: "Mar" },
        { column_name: "Apr", column_key_from_api: "Apr" },

        { column_name: "May", column_key_from_api: "May" },
        { column_name: "Jun", column_key_from_api: "Jun" },
        { column_name: "Jul", column_key_from_api: "Jul" },
        { column_name: "Aug", column_key_from_api: "Aug" },
        { column_name: "Sep", column_key_from_api: "Sep" },
        { column_name: "Oct", column_key_from_api: "Oct" },

        { column_name: "Nov", column_key_from_api: "Nov" },
        { column_name: "Dec", column_key_from_api: "Dec" },

        { column_name: "Total", column_key_from_api: "Total" },
      ],
    },

    {
      mode_table_name: "Profit Loss Month (Group)",
      mode_table_code: "PLMONTHGRP",
      mode_table_columns: [
        { column_name: "Account", column_key_from_api: "Account" },
        { column_name: "Descriptiion", column_key_from_api: "Descriptiion" },
        { column_name: "year", column_key_from_api: "year" },
        { column_name: "Jan", column_key_from_api: "Jan" },
        { column_name: "Feb", column_key_from_api: "Feb" },
        { column_name: "Mar", column_key_from_api: "Mar" },
        { column_name: "Apr", column_key_from_api: "Apr" },

        { column_name: "May", column_key_from_api: "May" },
        { column_name: "Jun", column_key_from_api: "Jun" },
        { column_name: "Jul", column_key_from_api: "Jul" },
        { column_name: "Aug", column_key_from_api: "Aug" },
        { column_name: "Sep", column_key_from_api: "Sep" },
        { column_name: "Oct", column_key_from_api: "Oct" },

        { column_name: "Nov", column_key_from_api: "Nov" },
        { column_name: "Dec", column_key_from_api: "Dec" },

        { column_name: "Total", column_key_from_api: "Total" },
      ],
    },
  ];

  const ModeComponent =
    modeComponentMap[
      parentDetails.mode_list_array?.find((item) => item.is_selected)?.mode_code
    ];
  const PDFComponent =
    pdfComponentMap[
      parentDetails.mode_list_array?.find((item) => item.is_selected)?.mode_code
    ];

  if (loadinggetFinancialDateApi) {
    return (
      <div className="flex items-center justify-center h-screen">
        <div className="text-lg font-semibold text-gray-600">
          Loading financial data...
        </div>
      </div>
    );
  }

  if (!datagetgetFinancialDateApi) {
    return (
      <div className="flex items-center justify-center h-screen text-red-600 font-semibold">
        Failed to load financial data. Please try again later.
      </div>
    );
  }
  console.log("🧩 Selected Mode:", selectedMode);
  console.log("🧩 Using component:", ModeComponent?.name);

  return (
    <div className="p-2">
      <FinancialReportBaseComponentHeader
        selectedMode={selectedMode}
        parentDetails={parentDetails}
        setParentDetails={setParentDetails}
        PDFComponent={PDFComponent || null}
        datagetTrialBalanceReport={cleanedData}
        selected_mode_table_structure={selected_mode_table_structure}
        datagetgetFinancialDateApi={datagetgetFinancialDateApi}
      />

      {loadinggetTrialBalanceReport && (
        <div className="text-center text-gray-500 mt-4">
          Loading report data...
        </div>
      )}

      {!loadinggetTrialBalanceReport && cleanedData && ModeComponent && (
        <ModeComponent
          key={
            parentDetails.mode_list_array?.find((item) => item.is_selected)
              ?.mode_code
          }
          datagetTrialBalanceReport={cleanedData}
          parentDetails={parentDetails}
          selected_mode_table_structure={selected_mode_table_structure}
        />
      )}
    </div>
  );
}

export default ProfitAndLossReport;
